module.exports = __webpack_public_path__ + "static/media/Layerblue.e862317d.svg";